import { AutoComplete } from 'antd';
import styled from 'styled-components';
import { ColoredPill, MuteText } from '../../elements';
import { RateListHook } from '../../hooks/rate';
import { theme } from '../../utility';
import { AutocompleteSearchInput } from '../../components';

const OptionContainer = styled.div`
  padding: 8px 12px;
`;

function resultRenderer({ search, name, isActive, _id, warehouseId }) {
  const showResult = string => {
    try {
      const highlighted = string.replace(
        new RegExp(search, 'gi'),
        d => `<strong>${d}</strong>`,
      );

      return <span dangerouslySetInnerHTML={{ __html: highlighted }} />;
    } catch (error) {
      return string;
    }
  };

  return (
    <OptionContainer className="d-flex flex-column" key={_id}>
      <div className="d-flex justify-content-between align-items-center">
        <span>{showResult(name)}</span>
        <MuteText>{warehouseId.name}</MuteText>
      </div>
      <ColoredPill color={isActive ? theme.colors.green : theme.colors.grey}>
        {isActive ? 'Active' : 'Not Active'}
      </ColoredPill>
    </OptionContainer>
  );
}

export function RateSearchInput({
  top,
  onResultClick,
  inputClassName,
  setTableSearch = () => {},
  size,
}) {
  const { data, loading, setSearch, filter } = RateListHook();

  const isSearching = loading && !!filter.search.trim();

  const options = (data ?? []).map(item => ({
    value: item._id,
    label: resultRenderer({ ...item, search: filter.search }),
  }));

  return (
    <AutoComplete
      className={inputClassName}
      style={{ width: '100%' }}
      value={filter.search}
      options={options}
      filterOption={false}
      placeholder="Rate Name"
      placement={top ? 'topLeft' : 'bottomLeft'}
      classNames={{ popup: { root: 'auto-search-dropdown' } }}
      onSearch={value => {
        setSearch(value);
        setTableSearch(value);
      }}
      onSelect={value => {
        const item = data.find(d => d._id === value);
        if (item?._id) {
          onResultClick(item);
          setSearch('');
        }
      }}
    >
      <AutocompleteSearchInput
        size={size}
        isSearching={isSearching}
        onClear={() => {
          setSearch('');
          setTableSearch('');
        }}
      />
    </AutoComplete>
  );
}
